export default "__VITE_ASSET__eab5c864__"